/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import * as userService from '@/services/user';
import LaunchApp from '@/shared/launchApp';
import { getURLInfo } from '@/shared/getUserInfo';
export default {
    __name: 'index',
    setup: function(__props) {
        var launchApp = ref(new LaunchApp({
            protocol: 'orale'
        }));
        var clickBtn = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var params, queryArr, key;
                return _ts_generator(this, function(_state) {
                    params = getURLInfo().params;
                    queryArr = [];
                    for(var key in params){
                        if (key !== 'openPath') {
                            queryArr.push("".concat(key, "=").concat(params[key]));
                        }
                    }
                    if (params.usage === '1') {
                        launchApp.value.open({
                            path: encodeURIComponent(params.openPath) + '&' + queryArr.join('&'),
                            onFaliure: /*#__PURE__*/ _async_to_generator(function() {
                                return _ts_generator(this, function(_state) {
                                    console.log('open fail');
                                    downloadApp();
                                    return [
                                        2
                                    ];
                                });
                            })
                        });
                    }
                    return [
                        2
                    ];
                });
            });
            return function clickBtn() {
                return _ref.apply(this, arguments);
            };
        }();
        var downloadApp = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var data, url, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                userService.queryDownloadType()
                            ];
                        case 1:
                            data = _state.sent();
                            url = '';
                            // 1 google play store;  2 oss
                            if (data.downloadAddrType === 1) {
                                // TODO: 添加链接
                                url = '';
                            } else if (data.downloadAddrType === 2) {
                                // TODO: 添加链接
                                url = '';
                            }
                            window.open(url);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            err = _state.sent();
                            console.log(err, 'err');
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function downloadApp() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            __sfc: true,
            launchApp: launchApp,
            clickBtn: clickBtn,
            downloadApp: downloadApp
        };
    }
};
